// extracted by mini-css-extract-plugin
export default {"vip_top":"vipTop_vip_top__MPvcl","left":"vipTop_left__eD9OV","right":"vipTop_right__cFw6K","text":"vipTop_text__zBwiR"};